export default {
    BusinessPurchaseOrderList: {
        order: 'Purchase Order No.',
        requisition: 'Purchase requisition number',
        type: 'Purchase Type',
        taxCode: 'Tax Code',
        status: 'Purchase order status',
        label: 'Purchase order tag',
        code: 'SKU',
        Creation: 'Creation Date',
        delivery: 'Estimated Arrival Date',
        Completion: 'Completion date',
        Generation: 'Generation date',
        View: 'View',
        production: 'Purchase order in production',
        tolerance: 'Data Fault Tolerance',
        over: 'Complete Procurement',
        Abandoned: 'Discard',
        chineseAudit1: 'Chinese First Audit',
        chineseAudit2: 'Chinese Second Audit',
        australianAudit: 'Australian Audit',
        contract: 'Contract No',
        source: 'Source',
        shippingCountry: 'Country of Shipment',
        table: {
            order: 'Purchase Order No.',
            requisition: 'Purchase requisition number',
            status: 'Purchase order status',
            label: 'Purchase order Tags',
            Buyer: 'Buyer',
            Creation: 'Creation Date',
            arrival: 'Estimated Arrival Date',
            Completion: 'Completion date',
            Generation: 'Generation date',
        },
        dataForm: {
            Purchase: 'Purchase Quantity',
            received: 'Actual received quantity',
            Difference: 'Difference',
            tolerant: 'Tolerance Quantity',
            fault: 'Data Fault Tolerance',
            empty: 'Tolerance Quantity cannot be empty',
        }
    }
};
